import { useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { SurveyInterface } from "../interfaces/survey_interface";
import { SurveyRepositoryImpl } from "../../data/repository/survey_repository_impl";

export const useHandleSurvey = (surveyId: string | undefined, initialSurvey?: SurveyInterface) => {
    const repository = new SurveyRepositoryImpl();

    const {
        data: survey,
        isLoading,
        error,
        refetch
    } = useQuery<SurveyInterface | null, AxiosError>({
        queryKey: ['survey', surveyId],
        queryFn: () => repository.getSurveyById(surveyId!),
        initialData: initialSurvey,
        retry: 4,
        enabled: !!surveyId,
        staleTime: 10 * 60 * 1000,
        gcTime: 30 * 60 * 1000,
    });

    return {
        survey,
        isLoading,
        error,
        refetch,
    };
};
